<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)
            v-layout(raw wrap)
                v-flex(xs12)

                    // Business information block title
                    title-component(
                        type="h4"
                        :title="$t('payments.payment.subtitle')"
                    )
            v-layout(raw wrap)

                v-flex(xs12 sm6)

                    // Card number
                    v-text-field(
                        :error-messages="errors.collect('cardNumber')"
                        :data-vv-as="$t('fields.cardNumber')"
                        :label="$t('fields.cardNumber')"
                        append-icon="credit_card"
                        name="cardNumber"
                        mask="credit-card"
                        v-model.lazy="model.number"
                        v-validate="'required|credit_card'"
                        outline
                    )

                v-flex(xs4 sm2)

                    // Month expiration
                    v-text-field(
                        type="number"
                        :error-messages="errors.collect('exp_month')"
                        :data-vv-as="$t('fields.monthExp')"
                        label="MM"
                        name="exp_month"
                        mask="##"
                        v-model.lazy="model.exp_month"
                        v-validate="'required|min:2|max:2|min_value:1|max_value:12'"
                        outline
                    )

                v-flex(xs4 sm2)

                    // Year expiration
                    v-text-field(
                        type="number"
                        :error-messages="errors.collect('exp_year')"
                        :data-vv-as="$t('fields.yearExp')"
                        label="YY"
                        name="exp_year"
                        mask="##"
                        v-model.lazy="model.exp_year"
                        v-validate="'required|min:2|max:2|min_value:20|max_value:99'"
                        outline
                    )

                v-flex(xs6 sm2)

                    // CVV
                    v-text-field(
                        type="number"
                        :error-messages="errors.collect('CVV')"
                        :data-vv-as="$t('fields.CVV')"
                        :label="$t('fields.CVV')"
                        name="CVV"
                        v-model.lazy="model.cvc"
                        v-validate="'required|numeric|min:3|max:4'"
                        outline
                    )

                v-flex(xs12)
                    div

                        // Delete button
                        a.deleteAction.mt-2(
                            :isLoading="isLoading"
                            @click="deleteCard"
                        )
                            div
                                v-icon(grey) delete
                                | {{ $t('payments.payment.deleteButton') }}
                v-flex(xs12)
                    // Horizontal line
                    separator-component

                    div.controls
                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="resetCard"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                :action="submit"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="primary"
                                large
                            ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapFields('payments', {
                model: 'paymentDetails'
            }),
            ...mapGetters('payments', ['isLoading']),
            ...mapGetters('auth', ['user']),
        },
        methods: {
            ...mapActions('payments', [
                'addNewCard',
                'deleteCard',
                'resetCard'
            ]),

            /**
             * Add card on submit
             * @returns {boolean}
             */
            async submit() {
                // Validate all fields and check in no errors
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                // Call store action Create Business account
                this.addNewCard();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    .deleteAction
        display: inline-block

        div
            display: flex
            align-items: center
            text-decoration: none
            font-size: 14px
            color: $theme.white

        .v-icon
            padding-right: 5px
            color: $theme.darkGrey

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .mobileMargin
            margin-bottom: 16px
</style>
